import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result } from '@digibricks/core';
import { ConfigType } from '../data-config';
import { FormReleaseInfo } from './form-release-info';
import { AssignmentMetadata } from '../assignment-metadata';
import { AssignmentType } from '../assignment-type';
import { UnixTimestamp } from '../unix-timestamp';
export var Assignment = /*#__PURE__*/function (_Entity) {
  _inherits(Assignment, _Entity);

  var _super = _createSuper(Assignment);

  function Assignment() {
    _classCallCheck(this, Assignment);

    return _super.apply(this, arguments);
  }

  _createClass(Assignment, [{
    key: "idNumber",
    get: function get() {
      return this.props.idNumber;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.props.duration;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "password",
    get: function get() {
      return this.props.password;
    }
  }, {
    key: "isShuffleQuestion",
    get: function get() {
      return this.props.isShuffleQuestion;
    }
  }, {
    key: "isShuffleAnswer",
    get: function get() {
      return this.props.isShuffleAnswer;
    }
  }, {
    key: "hasPassword",
    get: function get() {
      return this.props.hasPassword;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.props.startTime;
    }
  }, {
    key: "endTime",
    get: function get() {
      return this.props.endTime;
    }
  }, {
    key: "formReleaseInformation",
    get: function get() {
      return this.props.formReleaseInformation;
    }
  }, {
    key: "systemStatus",
    get: function get() {
      return this.props.systemStatus;
    }
  }, {
    key: "displayStatus",
    get: function get() {
      return this.props.displayStatus;
    }
  }, {
    key: "numberOfSubmission",
    get: function get() {
      return this.props.numberOfSubmission;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }, {
    key: "expectation",
    get: function get() {
      return this.props.expectation;
    }
  }, {
    key: "assigner",
    get: function get() {
      return this.props.assigner;
    }
  }, {
    key: "isShowingScore",
    get: function get() {
      return this.props.isShowingScore;
    }
  }, {
    key: "isShowingExplanationAndCorrectAnswers",
    get: function get() {
      return this.props.isShowingExplanationAndCorrectAnswers;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this.props.metadata;
    }
  }, {
    key: "isEnded",
    value: function isEnded() {
      switch (this.type.id) {
        case AssignmentType.Practice:
          {
            if (!this.endTime) {
              return false;
            }

            return this.endTime < UnixTimestamp.now();
          }

        case AssignmentType.Homework:
        case AssignmentType.Examination:
        default:
          {
            return this.endTime < UnixTimestamp.now();
          }
      }
    }
  }], [{
    key: "validateBaseProps",
    value: function validateBaseProps(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.isShuffleQuestion,
        argumentName: 'Is Shuffle Question'
      }, {
        argument: props.systemStatus,
        argumentName: 'System Status'
      }, {
        argument: props.numberOfSubmission,
        argumentName: 'Number of Submissions'
      }, {
        argument: props.isShowingExplanationAndCorrectAnswers,
        argumentName: 'Is Showing Explanation and Correct Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "createBasePropsFromJson",
    value: function createBasePropsFromJson(data) {
      try {
        var id = data.id,
            idNumber = data.idNumber,
            formReleaseInformation = data.formReleaseInformation,
            title = data.title,
            description = data.description,
            numberOfSubmission = data.numberOfSubmission,
            type = data.type,
            password = data.password,
            systemStatus = data.systemStatus,
            startTime = data.startTime,
            scoreVisibilityType = data.scoreVisibilityType,
            isShuffleQuestion = data.isShuffleQuestion,
            isShuffleAnswer = data.isShuffleAnswer,
            endTime = data.endTime,
            createdBy = data.createdBy,
            hasPassword = data.hasPassword,
            expectation = data.expectation,
            duration = data.duration,
            isShowingScore = data.isShowingScore,
            isShowingExplanationAndCorrectAnswers = data.isShowingExplanationAndCorrectAnswers,
            metadata = data.metadata;
        var typeOrError = ConfigType.create({
          id: type.id,
          name: type.name
        });

        if (typeOrError.isFailure) {
          return Result.fail(typeOrError.error);
        }

        var systemStatusOrError = ConfigType.create({
          id: systemStatus.id,
          name: systemStatus.name
        });

        if (systemStatusOrError.isFailure) {
          return Result.fail(systemStatusOrError.error);
        }

        var formReleaseInformationOrError = FormReleaseInfo.create({
          id: formReleaseInformation.id,
          version: formReleaseInformation.version,
          formId: formReleaseInformation.formId,
          totalScore: formReleaseInformation.totalScore,
          totalQuestions: formReleaseInformation.totalQuestions
        });

        if (formReleaseInformationOrError.isFailure) {
          return Result.fail(formReleaseInformationOrError.error);
        }

        var props = {
          id: id,
          idNumber: idNumber,
          title: title,
          description: description,
          numberOfSubmission: numberOfSubmission,
          formReleaseInformation: formReleaseInformationOrError.getValue(),
          type: typeOrError.getValue(),
          password: password,
          hasPassword: hasPassword,
          systemStatus: systemStatusOrError.getValue(),
          createdBy: createdBy,
          startTime: startTime,
          isShuffleQuestion: isShuffleQuestion,
          isShuffleAnswer: isShuffleAnswer,
          endTime: endTime,
          expectation: expectation,
          duration: duration,
          isShowingScore: isShowingScore,
          isShowingExplanationAndCorrectAnswers: isShowingExplanationAndCorrectAnswers
        };

        if (metadata) {
          var isGradedAllSubmission = metadata.isGradedAllSubmission;
          var metadataOrError = AssignmentMetadata.create({
            isGradedAllSubmission: isGradedAllSubmission
          });

          if (metadataOrError.isFailure) {
            return Result.fail(metadataOrError.error);
          }

          props.metadata = metadataOrError.getValue();
        }

        return Result.ok(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return Assignment;
}(Entity);